import React from "react";

export default function IconSearch() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6245 0.000198364C8.5578 0.000198364 5.2491 3.30893 5.2491 7.3756C5.2491 9.16801 5.89313 10.812 6.96019 12.0915L5.96731 13.0844L5.49317 12.6103C5.23121 12.3483 4.80676 12.3483 4.54481 12.6103L0.588186 16.5665C-0.19599 17.3511 -0.19599 18.6273 0.587756 19.412C0.588186 19.412 0.588186 19.412 0.588186 19.4124C1.37373 20.1962 2.64857 20.1957 3.43368 19.4124L7.38988 15.4553C7.65183 15.1934 7.65183 14.7689 7.38988 14.507L6.91574 14.0328L7.90863 13.04C9.18815 14.1071 10.8322 14.751 12.6246 14.751C16.6913 14.751 20 11.4423 20 7.37564C20 3.30897 16.6912 0.000198364 12.6245 0.000198364ZM12.6245 12.0684C10.0371 12.0684 7.93171 9.96305 7.93171 7.37564C7.93171 4.78823 10.0371 2.6828 12.6245 2.6828C15.2119 2.6828 17.3173 4.78819 17.3173 7.3756C17.3173 9.96301 15.2119 12.0684 12.6245 12.0684Z"
        fill="#"
      />
    </svg>
  );
}
